// UI-02 FIX: use REACT_APP_API_URL env var so production build works correctly
const BASE = process.env.REACT_APP_API_URL || "https://hashrial-api.wold-brunch-0r.workers.dev";

function getToken() { return localStorage.getItem("hashrial_token"); }

async function req(path, opts = {}) {
  const token = getToken();
  const res = await fetch(BASE + path, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(opts.headers || {}),
    },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  if (res.status === 401) {
    localStorage.removeItem("hashrial_token");
    window.location.href = "/login";
    return;
  }
  let data;
  try {
    data = await res.json();
  } catch {
    throw new Error(`Server error (${res.status})`);
  }
  if (!res.ok) throw new Error(data.error || "Request failed");
  return data;
}

export const api = {
  login:              (email, password) => req("/api/auth/login",    { method: "POST", body: { email, password } }),
  register:           (username, email, password, ref) => req("/api/auth/register", { method: "POST", body: { username, email, password, ...(ref ? { ref } : {}) } }),
  logout:             () => req("/api/auth/logout", { method: "POST" }),
  me:                 () => req("/api/auth/me"),
  forgotPassword:     (email) => req("/api/auth/forgot-password", { method: "POST", body: { email } }),
  resetPassword:      (token, password) => req("/api/auth/reset-password", { method: "POST", body: { token, password } }),
  verifyEmail:        (token) => req("/api/auth/verify-email", { method: "POST", body: { token } }),
  resendVerification: (email) => req("/api/auth/resend-verification", { method: "POST", body: { email } }),
  changePassword:     (currentPassword, newPassword) => req("/api/auth/change-password", { method: "POST", body: { currentPassword, newPassword } }),
  overview:           () => req("/api/dashboard/overview"),
  hashrate:           (period, worker) => req(`/api/dashboard/hashrate?period=${period}${worker ? `&worker=${worker}` : ""}`),
  /* Normalised to one shape. The endpoint returned a bare array before it
     started reporting the pool's shortest hashrate window, and a cached
     response can still be the old shape. 10 is the pre-Braiins default. */
  workers:            () => req("/api/dashboard/workers").then(r =>
                        Array.isArray(r)
                          ? { workers: r, hashrateWindowMin: 10 }
                          : { workers: r?.workers || [], hashrateWindowMin: r?.hashrateWindowMin || 10 }),
  workerDetail:       (name) => req(`/api/dashboard/workers/${encodeURIComponent(name)}`),
  earnings:           (page = 1) => req(`/api/dashboard/earnings?page=${page}`),
  notifications:      () => req("/api/notifications"),
  markRead:           () => req("/api/notifications/read", { method: "POST" }),
  connectInfo:        () => req("/api/connect"),
  poolStats:          () => req("/api/pool/stats"),
  btcPrice:           () => req("/api/public/btcprice"),
  updateNotifySettings: (s) => req("/api/settings/notifications", { method: "PUT", body: s }),
  notifySettings:     () => req("/api/settings/notifications"),
  setPayoutAddress:   (bitcoin_address) => req("/api/settings/payout-address", { method: "PUT", body: { bitcoin_address } }),
  requestPayout:      () => req("/api/payout/request", { method: "POST" }),
  payoutHistory:      () => req("/api/payout/history"),
  referralStats:      () => req("/api/referral/stats"),
  referralSetCode:    (code) => req("/api/referral/code", { method: "POST", body: { code } }),
  adminOverview:      () => req("/api/admin/overview"),
  adminSetPayoutStatus: (id, status, txid) => req("/api/admin/payout-status", { method: "PUT", body: { id, status, txid } }),
};
